import get from 'lodash-es/get';

import { API_S3_LOCATION_UPLOAD_INFO_URL } from '../../../constants/apiUrls';
import { getRequestJSON, uploadFile, uploadToS3Request } from '../../../util/services';

// The pieces of a Ventura location batch upload that don't depend on how the file
// was produced: Batch Add drops a user's file through S3Upload, the ESRI builder
// generates one in the browser. Both then start the job with useBatchLocationJob.

const NAME_VALIDATED_MOMENTS_TYPES = ['NotMoments', 'ListMoments', 'inpathmoments', 'inhomemoments'];

export const duplicateValidationPath = (momentsType: string): string =>
  NAME_VALIDATED_MOMENTS_TYPES.includes(momentsType)
    ? '/admin/locations/validate_duplicate_name'
    : '/admin/locations/validate_duplicate_poi_id';

export interface DuplicateValidation {
  valid: boolean;
  message?: string;
}

export const validateLocationFile = async (
  apiHost: string,
  momentsType: string,
  file: Blob
): Promise<DuplicateValidation> => {
  const response = await uploadFile(apiHost, duplicateValidationPath(momentsType), null, file);
  const valid = get(response, 'valid', false);
  if (valid) return { valid };
  return { valid, message: `${get(response, 'title', '')}: ${get(response, 'message', '')}` };
};

const cleanName = (name: string) => name.trim().replace(/[^A-Za-z0-9\-. @|!~[\]_]/g, '');

// Extensionless; S3Upload appends the file's extension.
export const generateLocationUploadKey = (
  prefix: string,
  lineItemId: number,
  adGroupId: number,
  adGroupName: string
): string => `${prefix}${lineItemId}/${adGroupId}_${new Date().getTime()}_${cleanName(adGroupName)}`;

// S3Upload's single-file path for a file that never went through a drop zone.
export const uploadLocationFileToS3 = async (
  apiHost: string,
  s3DirectUploadUrl: string,
  file: Blob,
  s3Key: string
): Promise<void> => {
  const { bucket, form_data: formData } = await getRequestJSON(`${apiHost}${API_S3_LOCATION_UPLOAD_INFO_URL}`);
  await uploadToS3Request(s3DirectUploadUrl, `/${bucket}`, formData, file, s3Key);
};
